<template>
    <fragment>
        
    <recruiter-job-offers-history
      :job-offers="jobOffersActive"
      :is-loading="saveLoading"
    />
   
    <div class="my-3" />
    <recruiter-job-offers-history
      :job-offers="jobOffersClosed"
      :is-loading="saveLoading"
      :variant="JOB_OFFERS_STATUSES.CLOSED"
    />

    </fragment>
  </template>
  
  <script>
  import { JOB_OFFER_STATUSES } from '@/store';
  import RecruiterJobOffersHistory from '@/components/recruiter/job_offers/RecruiterJobOffersHistory';

  const compareActiveJobOffersStatus = (jo) => {
    return jo.status === JOB_OFFER_STATUSES.DRAFT ? 0 : 1;
    };

  export default {
    name: 'RecruiterPurchaseHistoryList',
    components: {
        RecruiterJobOffersHistory
    },
    props: {
        jobOffers: {
            validator: (prop) => typeof prop === 'object' || prop === null,
            default: null,
        },
        saveLoading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        JOB_OFFERS_STATUSES: function () {
            return JOB_OFFER_STATUSES;
        },
        jobOffersActive: function () {
            return (this.jobOffers || []).filter((jo) => {
                return [
                    JOB_OFFER_STATUSES.ACTIVE,
                    JOB_OFFER_STATUSES.DRAFT,
                    JOB_OFFER_STATUSES.FILLED
                ].includes(jo.status);
            })
            .sort(compareActiveJobOffersStatus);
        },
        jobOffersClosed: function () {
            return (this.jobOffers || []).filter(
            (jo) => jo.status === JOB_OFFER_STATUSES.CLOSED
            );
        },
    },
    methods: {
     
    },
  };
  </script>
  
  <style lang="scss">
  .required:after {
    content: '*';
    color: red;
    display: inline-block;
    margin-left: 4px;
    font-size: 26px;
    line-height: 20px;
  }
  .form-control {
    color: black;
  }
  </style>
  